export function formatVideoTimestamp(ms) {
    const totalMs = Math.max(0, Math.round(Number(ms) || 0));
    const hours = Math.floor(totalMs / 3600000);
    const minutes = Math.floor((totalMs % 3600000) / 60000);
    const seconds = Math.floor((totalMs % 60000) / 1000);
    const millis = totalMs % 1000;

    const pad2 = (n) => String(n).padStart(2, "0");
    const pad3 = (n) => String(n).padStart(3, "0");

    if (hours > 0) {
        return `${hours}:${pad2(minutes)}:${pad2(seconds)}.${pad3(millis)}`;
    }
    return `${pad2(minutes)}:${pad2(seconds)}.${pad3(millis)}`;
}

function formatSubtitleClock(ms, separator) {
    const totalMs = Math.max(0, Math.round(Number(ms) || 0));
    const hours = Math.floor(totalMs / 3600000);
    const minutes = Math.floor((totalMs % 3600000) / 60000);
    const seconds = Math.floor((totalMs % 60000) / 1000);
    const millis = totalMs % 1000;
    const pad2 = (n) => String(n).padStart(2, "0");
    const pad3 = (n) => String(n).padStart(3, "0");
    return `${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)}${separator}${pad3(millis)}`;
}

function computeEndMs(comments, index, videoDurationMs) {
    const start = comments[index].timestampMs;
    const nextStart = index < comments.length - 1 ? comments[index + 1].timestampMs : null;

    let end;
    if (nextStart != null) {
        end = Math.min(nextStart - 100, start + 5000);
    } else {
        end = start + 3000;
    }

    if (end - start < 1500) {
        end = start + 1500;
    }

    if (videoDurationMs != null && end > videoDurationMs) {
        end = videoDurationMs;
    }

    return Math.max(end, start + 1500);
}

function formatCommentLine(comment, includeReviewerName) {
    if (includeReviewerName && comment.reviewerName) {
        return `[${comment.reviewerName}] ${comment.body}`;
    }
    return comment.body;
}

export function commentsToSrt(comments, { includeReviewerName = true, videoDurationMs } = {}) {
    const sorted = [...comments].sort((a, b) => a.timestampMs - b.timestampMs || a.createdAt - b.createdAt);
    const blocks = sorted.map((comment, index) => {
        const start = comment.timestampMs;
        const end = computeEndMs(sorted, index, videoDurationMs);
        const text = formatCommentLine(comment, includeReviewerName);
        return `${index + 1}\n${formatSubtitleClock(start, ",")} --> ${formatSubtitleClock(end, ",")}\n${text}\n`;
    });
    return blocks.join("\n");
}

export function commentsToVtt(comments, options = {}) {
    const sorted = [...comments].sort((a, b) => a.timestampMs - b.timestampMs || a.createdAt - b.createdAt);
    const blocks = sorted.map((comment, index) => {
        const start = comment.timestampMs;
        const end = computeEndMs(sorted, index, options.videoDurationMs);
        const text = formatCommentLine(comment, options.includeReviewerName !== false);
        return `${index + 1}\n${formatSubtitleClock(start, ".")} --> ${formatSubtitleClock(end, ".")}\n${text}\n`;
    });
    return `WEBVTT\n\n${blocks.join("\n")}`;
}

export function downloadTextFile(filename, content, { bom = false } = {}) {
    const parts = bom ? ["\uFEFF", content] : [content];
    const blob = new Blob(parts, { type: "text/plain;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export function sanitizeFilename(name) {
    return (name || "video-review")
        .replace(/[<>:"/\\|?*]/g, "_")
        .trim()
        .slice(0, 80) || "video-review";
}
